import IDerivedCloudinaryAsset from './IDerivedAsset';

/* eslint-disable @typescript-eslint/naming-convention */

export default interface ICloudinaryAsset {
	bytes: number;
	context: Record<string, any>;
	created_at: string;
	derived?: IDerivedCloudinaryAsset[];
	format: string;
	height: number;
	public_id: string;
	resource_type: string; //
	secure_url: string;
	tags: string[];
	type: string;
	url: string;
	version: string;
	width: number;
	duration?: number;
}

// Type Guard
export function isCloudinaryAsset(object: any | ICloudinaryAsset): object is ICloudinaryAsset {
	return (
		object &&
		(object as ICloudinaryAsset).bytes !== undefined &&
		(object as ICloudinaryAsset).created_at !== undefined &&
		(object as ICloudinaryAsset).format !== undefined &&
		(object as ICloudinaryAsset).height !== undefined &&
		(object as ICloudinaryAsset).public_id !== undefined &&
		(object as ICloudinaryAsset).resource_type !== undefined &&
		(object as ICloudinaryAsset).secure_url !== undefined &&
		(object as ICloudinaryAsset).tags !== undefined &&
		(object as ICloudinaryAsset).type !== undefined &&
		(object as ICloudinaryAsset).url !== undefined &&
		(object as ICloudinaryAsset).url !== undefined &&
		(object as ICloudinaryAsset).width !== undefined
	);
}

/* eslint-enable @typescript-eslint/naming-convention */
